import { DefaultEventsMap } from "@socket.io/component-emitter";
import { Socket, io } from "socket.io-client";
import { getCookie } from "./CookieHelper";
import { COOKIE_ENUM, SOCKET_NAMESPACE } from "./enums";
import envConfig from "./env.config";

let socket: Socket<DefaultEventsMap, DefaultEventsMap> | undefined | null;
let franchiseSocket:
  | Socket<DefaultEventsMap, DefaultEventsMap>
  | undefined
  | null;

export const getSocket = (
  nameSpace: SOCKET_NAMESPACE,
  restaurantId: string
) => {
  const token = getCookie(COOKIE_ENUM.TOKEN);

  // Check if socket exists and is connected to the same restaurant
  if (
    socket &&
    socket.active &&
    socket.io.opts.query?.restaurantId === restaurantId
  ) {
    return socket;
  }

  // Disconnect previous socket if restaurantId changes
  if (socket) {
    console.log(
      `Disconnecting old restaurant socket for ID: ${socket.io.opts.query?.restaurantId}`
    );
    socket.disconnect();
  }

  // Create a new socket connection
  socket = io(envConfig.baseUrl + nameSpace, {
    transports: ["websocket", "polling"],
    query: { restaurantId, token },
  });

  console.log(`New restaurant socket created for ID: ${restaurantId}`);

  return socket;
};

export const getFranchiseSocket = (
  nameSpace: SOCKET_NAMESPACE,
  franchiseId: string
) => {
  const token = getCookie(COOKIE_ENUM.TOKEN);

  // Check if franchiseSocket exists and is connected to the same franchise
  if (
    franchiseSocket &&
    franchiseSocket.active &&
    franchiseSocket.io.opts.query?.franchiseId === franchiseId
  ) {
    return franchiseSocket;
  }

  // Disconnect previous franchiseSocket if franchiseId changes
  if (franchiseSocket) {
    console.log(
      `Disconnecting old franchise socket for ID: ${franchiseSocket.io.opts.query?.franchiseId}`
    );
    franchiseSocket.disconnect();
  }

  // Create a new socket connection
  franchiseSocket = io(envConfig.baseUrl + nameSpace, {
    transports: ["websocket", "polling"],
    query: { franchiseId, token },
  });

  console.log(`New franchise socket created for ID: ${franchiseId}`);

  return franchiseSocket;
};
